import { useCallback, useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

import { ModalContext } from '../../../contexts/ModalContext';
import { MODAL_CANCEL_TRIAL } from '../constants';
import { cancelTrial } from '../../../domains/trials/api/cancelTrial';
import styles from './TrialCancelModal.module.css';

const TrialCancelModal = () => {
  const { isModalOpen, closeModal, openModalProps } =
    useContext(ModalContext) || {};

  const isOpen = isModalOpen?.(MODAL_CANCEL_TRIAL);

  const { modalProps, onSuccess } =
    (openModalProps?.[MODAL_CANCEL_TRIAL] as {
      modalProps: Record<string, string>;
      onSuccess: () => void;
    }) || {};

  const handleCloseModal = useCallback(() => {
    closeModal?.(MODAL_CANCEL_TRIAL);
  }, [closeModal]);

  const handleCancelTrial = async () => {
    if (!modalProps.bundleId) {
      return;
    }

    const errorMessage = `Unable to cancel trial for site_id: ${modalProps?.siteId}`;

    await cancelTrial({
      bundleId: modalProps.bundleId,
      errorMessage,
      accountId: Number(modalProps?.accountId),
    });

    onSuccess();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isOpen ?? false}
      onClose={handleCloseModal}
    >
      <DialogTitle>Cancel Trial</DialogTitle>
      <DialogContent>
        <p className={styles.info}>
          You're about to cancel a trial for site{' '}
          {modalProps?.name ? modalProps.name : `ID: ${modalProps?.siteId}`}
        </p>
        <p>Are you sure you want to cancel trial?</p>
        <p>
          Once you cancel the trial, we will send an email to the account owner
          that trial ended.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button variant="contained" onClick={handleCancelTrial}>
          Cancel trial
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrialCancelModal;
